export interface EntityModeMultipleSelect {
    active: boolean;
    listCode: string[];
}

export const EntityModeMultipleSelectInit: EntityModeMultipleSelect = {
    active: false,
    listCode: []
}